const getters = {
    token: state => state.user.token,
};

export default getters;
  


// WEBPACK FOOTER //
// ./src/store/getters.js